/**
 * TimelineBlock — the data contract for chronological timeline components.
 *
 * This is a pure TypeScript file with zero framework imports.
 * Backend tool schemas (Zod) should mirror these types.
 */

export interface TimelineEvent {
  date: string;
  title: string;
  description?: string;
  type?: string;
  icon?: string;
  deep_link?: string;
  metadata?: Record<string, string>;
}

export interface TimelineBlock {
  title: string;
  events: TimelineEvent[];
  order?: 'newest_first' | 'oldest_first';
  entity?: string;
  entity_deep_link?: string;
}

export function isValidTimelineBlock(data: unknown): data is TimelineBlock {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  if (typeof d.title !== 'string') return false;
  if (!Array.isArray(d.events) || d.events.length === 0) return false;
  return d.events.every(
    (e: unknown) =>
      e &&
      typeof e === 'object' &&
      typeof (e as Record<string, unknown>).date === 'string' &&
      typeof (e as Record<string, unknown>).title === 'string'
  );
}
